import {
    ReactElement,
    ButtonHTMLAttributes
} from "react";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
    image: string;
    myStyle?: string;
    count?: number
}

export function ButtonIcon({ image, myStyle, count }: Props): ReactElement {


    return (
        <div className={`button-icon ${myStyle && myStyle} ${count && "my-badge"} cursor-pointer`}>
            <img src={image} alt="هامرز" />
                       {count &&
                    <span>
                        {count}
                    </span>
            }
        </div>
    )
}

export default ButtonIcon;